import { render, staticRenderFns } from "./CustomerCart.vue?vue&type=template&id=55dfa0a1"
import script from "./CustomerCart.vue?vue&type=script&lang=js"
export * from "./CustomerCart.vue?vue&type=script&lang=js"
import style0 from "./CustomerCart.vue?vue&type=style&index=0&id=55dfa0a1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports